import { render, staticRenderFns } from "./MedicalVisite.vue?vue&type=template&id=7fd599ad&"
import script from "./MedicalVisite.vue?vue&type=script&lang=js&"
export * from "./MedicalVisite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports